// extracted by mini-css-extract-plugin
export default {"main-page-not-found":"accessDenied_main-page-not-found__FUfjK","image-page-not-found":"accessDenied_image-page-not-found__gtSDH"};